import { ComponentProps } from 'react'
import { Image as UuiImage } from 'utoniq-ui'

import { config } from '../../config'

export type StorageImageProps = {
  target?: 'app' | 'common'
} & ComponentProps<typeof UuiImage>

/**
 * @description
 * Cloud StorageのURLを参照するImageコンポーネント
 *
 * @param target
 * URLの参照先を指定する
 * appの場合はアプリ毎ディレクトリを
 * commonの場合は共通ディレクトリを参照する
 * cf ) https://app.clickup.com/908127/v/dc/vpuz-82/vpuz-7325
 */

export const StorageImage = ({
  target = 'app',
  ...props
}: StorageImageProps) => {
  const storageUrl =
    target === 'app' ? config.appStorageUrl : config.commonStorageUrl

  return <UuiImage {...props} src={new URL(props.src || '', storageUrl).href} />
}
